import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IPackage } from '../models/packages/package';
import { PackageDeleteResult, PackageListResult, PackageResult } from '../models/packages/package-result';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class PackagesService {
  constructor(private http: HttpClient) {}

  listPackages(orgId: string | null): Observable<IPackage[]> {
    const url = `${environment.apiBase}/packages?org_id=${orgId}`;
    if (isDevMode()) {
      console.log('[DEV] [PackagesService] loading packages');
    }
    return this.http.get<PackageListResult>(url, httpOptions).pipe(map((res: PackageListResult) => res.packages));
  }

  detailPackage(id: string): Observable<IPackage> {
    if (isDevMode()) {
      console.log('[DEV] [PackagesService] loading package details', id);
    }
    const url = `${environment.apiBase}/packages/${id}`;
    return this.http.get<PackageResult>(url, httpOptions).pipe(map((res: PackageResult) => res.package));
  }

  createPackage(newPackage: IPackage): Observable<PackageResult> {
    const url = `${environment.apiBase}/packages`;
    if (isDevMode()) {
      console.log('[DEV] [PackagesService] creating package', newPackage);
    }
    return this.http.post<PackageResult>(url, newPackage, httpOptions);
  }

  deletePackage(_package: IPackage): Observable<PackageDeleteResult> {
    if (isDevMode()) {
      console.log('[DEV] [PackagesService] deleting package', _package);
    }
    const url = `${environment.apiBase}/packages/${_package.id}`;
    return this.http.delete<PackageDeleteResult>(url, httpOptions);
  }

  updatePackage(updatePackage: IPackage): Observable<PackageResult> {
    const url = `${environment.apiBase}/packages/${updatePackage.id}`;
    if (isDevMode()) {
      console.log('[DEV] [PackagesService] updating package', updatePackage);
    }
    return this.http.put<PackageResult>(url, updatePackage, httpOptions);
  }
}
